import React, { useState } from 'react';

import type { MemberDTO } from '../../services/apiClient';

import Button from '../../components/common/Button';
import FormField from '../../components/common/FormField';
import handleChange from '../../utils/formUtils/handleChange';
import Form from '../common/Form';
import FormSection from '../common/FormSection';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface MemberFormProps {
  initialValues: MemberDTO;
  onSubmit: (data: MemberDTO) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
}

const FORM_SECTIONS = {
  profilePicture: {
    id: 'basic-info',
    title: 'Basic Information',
  }
} as const;

const MemberForm: React.FC<MemberFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isSubmitting = false,
}) => {
  const [formData, setFormData] = useState<MemberDTO>(initialValues);

  const sections = Object.values(FORM_SECTIONS);

  const validationRules: ValidationRules = {
  // Member Section
  membershipNumber: [
    { required: true, message: 'Membership Number is required' },
  ],
  firstName: [
    { required: true, message: 'First Name is required' },
  ],
  lastName: [
    { required: true, message: 'Last Name is required' },
  ],
  email: [
    { required: true, message: 'Email is required' },
  ],
};

  const { errors, validate } = useFormValidation<MemberDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };


  return (
    <Form
      sections={sections}
      onSave={handleSave}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
    >
      <FormSection
        id={FORM_SECTIONS.profilePicture.id}
        title={FORM_SECTIONS.profilePicture.title}
        columns={2}
      >
        <FormField
          id="membershipNumber"
          label="Membership Number"
          type="text"
          value={formData.membershipNumber || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Membership Number"
          required={true}
          error={errors.membershipNumber}
        />
        <FormField
          id="firstName"
          label="First Name"
          type="text"
          value={formData.firstName || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter First Name"
          required={true}
          error={errors.firstName}
        />
        <FormField
          id="lastName"
          label="Last Name"
          type="text"
          value={formData.lastName || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Last Name"
          required={true}
          error={errors.lastName}
        />
        <FormField
          id="email"
          label="Email"
          type="email"
          value={formData.email || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Email"
          required={true}
          error={errors.email}
        />
        <FormField
          id="phone"
          label="Phone"
          type="text"
          value={formData.phone || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Email"
        />
      </FormSection>
      </Form>
  );
};

export default MemberForm;
